import { Controller } from "@hotwired/stimulus";

// The "Zobacz wszystkie" overlay: the list is rendered server side, this only
// opens and closes it on the theme's own is-open class, with a hidden
// attribute so the panel stays out of the tab order while closed.
export default class extends Controller {
  static targets = ["modal"];

  open(event) {
    if (event) event.preventDefault();
    this.modalTarget.hidden = false;
    requestAnimationFrame(() => this.modalTarget.classList.add("is-open"));
    document.documentElement.classList.add("allmeds-lock");
  }

  close() {
    this.modalTarget.classList.remove("is-open");
    document.documentElement.classList.remove("allmeds-lock");
    setTimeout(() => { this.modalTarget.hidden = true; }, 280);
  }

  // Escape closes the list, unless the player is open on top of it.
  keydown(event) {
    if (event.key !== "Escape" || this.modalTarget.hidden) return;
    const player = document.getElementById("playerModal");
    if (player && player.classList.contains("is-open")) return;
    this.close();
  }
}
